import { Box } from "@mui/material"
import { AboutTheData } from "../../AboutTheData"

interface DataSourceTabLayoutProps {
  aboutContent: string[]
  children: React.ReactNode
}

export const DataSourceTabLayout: React.FC<DataSourceTabLayoutProps> = ({
  aboutContent,
  children,
}) => {
  return (
    <Box>
      <AboutTheData>{aboutContent.join("\n\n")}</AboutTheData>
      <Box sx={{ marginTop: "24px" }}>{children}</Box>
    </Box>
  )
}
